// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"GlobalCTAPanel_panelContainer__7kjlM","ctasContainer":"GlobalCTAPanel_ctasContainer__rOi27","phoneButton":"GlobalCTAPanel_phoneButton__jm6ny"};